export default "__VITE_ASSET__DJXfyxB6__"